import localMarketingEvents from '../airtable/marketing';
import { MarketingCommunityEvent } from '../airtable/marketing.types';

//  Events fetched from the server.
let serverEvents: MarketingCommunityEvent[] = [];

export function getLocalMarketingEvents(): MarketingCommunityEvent[] {
  return localMarketingEvents;
}

export function getServerMarketingEvents(): MarketingCommunityEvent[] {
  return serverEvents;
}

export function setServerMarketingEvents(
  events: MarketingCommunityEvent[],
): void {
  serverEvents = events;
}
